module.exports = __webpack_public_path__ + "static/media/overlay.6d03983c.png";